import { render, staticRenderFns } from "./nav-configuration-modal.vue?vue&type=template&id=21f7be2a&scoped=true&"
import script from "./nav-configuration-modal.vue?vue&type=script&lang=ts&"
export * from "./nav-configuration-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f7be2a",
  null
  
)

export default component.exports